import { render, staticRenderFns } from "./InvoiceDetails.vue?vue&type=template&id=61abd346&scoped=true&"
import script from "./InvoiceDetails.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDetails.vue?vue&type=style&index=0&id=61abd346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61abd346",
  null
  
)

export default component.exports